import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import searchIcon from "../../../assets/images/dashboard-search.svg";
import uploadIcon from "../../../assets/images/uploadd.png";
import filterIcon from "../../../assets/images/filter.svg";
import { Tooltip } from "@mui/material";
import appliedFiltersIcon from "../../../assets/images/filterApplied.svg";
import exportIcon from '../../../assets/images/exportIcon.svg';

interface DashboardHeaderProps {
  title?: string;
  onSearch: (value: string) => void; 
  setSearchPopup?: (value: boolean) => void;
  onClick?: () => void;
  errors?: number;
  totalDataLength?: number;
  appliedFilters?: any;
  dashboardClassname?: string;
  enableFilter?: boolean;
  enableExport?: boolean; 
  onExport?: () => void;
  searchValue: {
    value: string;
    open: boolean;
  };
  filterPills?: React.ReactNode;
  setSearchValue?: (value: { value: string; open: boolean }) => void;
  onFilterClick?: () => void;
  onSearchValueChange: (val: string) => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  onSearch,
  setSearchPopup, 
  title,
  enableFilter,
  enableExport, // <-- add this
  onExport,     // <-- add this
  appliedFilters,
  filterPills,
  onClick,
  onFilterClick,
  errors,
  totalDataLength,
  dashboardClassname,
  searchValue,
  setSearchValue,
  onSearchValueChange,
}) => {
  const [debouncedValue, setDebouncedValue] = useState("");

  const searchInput = (value: string) => {
    onSearchValueChange(value);
  };

  const hasAppliedFilters = appliedFilters && Object.keys(appliedFilters).length > 0;

  return (
    <div
      className={`${styles.dashboardHeader} ${dashboardClassname || ""}`}
      data-testid="dashboard-header"
    >
      <div className={styles.heading}>
        {title || "List of registrations"}
        {errors !== undefined &&
          totalDataLength !== undefined &&
          errors > 0 &&
          errors < totalDataLength && (
            <div className={styles.errorMsg}>
              &nbsp;&nbsp;({errors} invalid rows found in the file. only valid
              rows will be uploaded)
            </div>
          )}
        {errors !== undefined &&
          totalDataLength !== undefined &&
          errors > 0 &&
          errors === totalDataLength && (
            <div className={styles.errorMsg}>
              &nbsp;&nbsp;(All rows are invalid, can&apos;t upload the file)
            </div>
          )}
        {filterPills}
      </div>
      
      <div className={styles.iconsBlock} data-testid="icons-block">
        {searchValue.open && (
          <div className={styles.search} data-testid="search-container">
            <input
              type="text"
              className={styles.searchInput}
              autoFocus
              value={searchValue.value}
              placeholder="Search seeker with name or mobile number"
              onChange={(e) => {
                onSearchValueChange(e.target.value);
                if (e.target.value === "") {
                  onSearch(""); // Trigger search when cleared
                  setTimeout(() => {
                    setSearchValue && setSearchValue({ value: "", open: false });
                  }, 500); // closes after 0.5 seconds, adjust as needed
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSearch(searchValue.value.trim());
                }
              }}
              data-testid="search-input"
            />
          </div>
        )}
        <Tooltip title="Search" arrow>
          <button className={styles.filter} data-testid="search-button">
            <img
              src={searchIcon}
              alt="search"
              data-testid="search-icon"
              onClick={() =>
                setSearchValue &&
                setSearchValue({
                  value: searchValue.value,
                  open: !searchValue.open,
                })
              }
            />
          </button>
        </Tooltip>
        {errors !== undefined &&
          totalDataLength !== undefined &&
          errors < totalDataLength && (
            <Tooltip title="upload" arrow>
              <button className={styles.filter} data-testid="search-button">
                <img
                  src={uploadIcon}
                  alt="upload"
                  className={styles.uploadIcon}
                  data-testid="search-icon"
                  onClick={() => onClick && onClick()}
                />
              </button>
            </Tooltip>
          )}
       
        {enableFilter && (
          <Tooltip title="Filter" arrow>
            <button className={styles.filter} onClick={onFilterClick}>
              <img
                src={hasAppliedFilters ? appliedFiltersIcon : filterIcon}
                alt="filter icon"
                data-testid="filter-icon"
              />
            </button>
          </Tooltip>
        )}
         {enableExport && (
          <Tooltip title="Export" arrow>
            <button
              className={styles.filter}
              data-testid="export-button"
              onClick={onExport}
            >
              <img
                src={exportIcon}
                alt="export"
                className={styles.exportIcon}
                data-testid="export-icon"
              />
            </button>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default DashboardHeader;